module.exports = __webpack_public_path__ + "img/jelen_van_bg_1360_cs.54453d1a.png";